import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as Papa from 'papaparse';

@Component({
  selector: 'app-soc-modal',
  templateUrl: './soc-modal.component.html',
  styleUrls: ['./soc-modal.component.scss'],
})
export class SocModalComponent implements OnInit {
  isLoading = true;
  Errors = null;
  socs = null;
  mode = null;
  data = null;
  Success = null;
  visible = false;
  serchItems = [];
  items = [];
  itemName;
  opds: any = [];
  itemId;
  itemAmount = 0;
  discount = 0;
  discountPrice = 0;
  netAmount = 0;
  lstServices: any = [];
  filterddata: any = [];
  companies: any[];
  branchs: any[];
  allIds: any = [];
  SOC_ID: any = '';
  isLoading1 = false;
  idItem = '';
  itemsAll = [];
  jsonData: any[] = [];
  formatCSVData: any[] = [];
  socItems: any[] = [];

  packages: any = [];
  stateForm = new FormGroup({
    SOC_NAME: new FormControl('', Validators.required),
    SOC_ID: new FormControl(null, Validators.required),
    SOC_Short_COde: new FormControl('', Validators.required),
    Status: new FormControl('', Validators.required),
    SOC_REMARKs: new FormControl('', Validators.required),
    Author_Id: new FormControl(0, Validators.required),
    company_id: new FormControl(0, Validators.required),
    branch_code: new FormControl('', Validators.required),
  });

  copyForm = new FormGroup({
    select_soc: new FormControl('', Validators.required),
    base_soc: new FormControl(1, Validators.required),
    rate_type: new FormControl('', Validators.required),
    rate_percent: new FormControl('', Validators.required),
    amount: new FormControl(0),
  });
  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService
  ) {}

  private sampleData = [
    { name: 'Item 1', price: 100 },
    { name: 'Item 2', price: 200 },
    // ... more data
  ];
  private resetFileInput(): void {
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  downloadCsv(): void {
    const headers = 'name,price\n';
    const rows = this.sampleData.map((d) => `${d.name},${d.price}`).join('\n');
    const csvData = headers + rows;

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'template.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  downloadAllSoc(id): void {
    console.log(id);
    this.auth.getItemBySocId(id.SOC_ID).subscribe(
      (resSuccess: any) => {
        this.socItems = resSuccess;
        console.log(this.socItems, 'Socccccccc');
        const headers = 'dept_name,sub_dept_name,name,service_price\n';
        const rows = this.items
          .map(
            (d) =>
              `${d.dept_name},${d.sub_dept_name},${d.name},${d.service_price}`
          )
          .join('\n');
        const csvData = headers + rows;

        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'SOC List.csv';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  onFileChange(event: any): void {
    let data = {
      soc_id: +this.copyForm.value.select_soc,
    };
    if (!data.soc_id) {
      this._snackBar.open('Please select a valid SOC', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
      this.resetFileInput();
    } else {
      const file = event.target.files[0];

      Papa.parse(file, {
        complete: (result) => {
          console.log('Parsed:', result);
          this.jsonData = result?.data;
          console.log(this.jsonData, 'Jsonnnnn');
          this.formatCSVData = this.jsonData.map((item, index) => ({
            soc_id: +this.copyForm.value.select_soc,
            item_id: 1610,
            amount: parseInt(item.price),
            name: item.name,
          }));
          this.itemsAll = this.formatCSVData.reduce((acc, item) => {
            const found = this.items.find(
              (singleItem) => singleItem.name === item.name
            );
            if (found) {
              acc.push({ ...item, item_id: found.id });
            }
            return acc;
          }, []);

          console.log(this.itemsAll);
          console.log(this.items, 'All Itemssssssss');
        },
        header: true,
      });
    }
  }

  refchg(value) {
    console.log(value);
    if (value == '') {
      this.visible = false;
    } else {
      this.visible = true;
    }
    this.serchItems = this.items.filter(
      (t) => t.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  refchg1(value) {
    if (value == '') {
      this.visible = false;
    } else {
      this.visible = true;
    }
    this.serchItems = this.items.filter(
      (t) => t.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
    this.idItem = value;
  }
  setItem(item) {
    this.itemName = item.name;
    this.itemId = item.id;
    this.itemAmount = item.service_price;
    console.log(item);

    this.visible = false;
    console.log(this.stateForm.value);
  }
  setItem1(item) {
    this.itemId = item.id;
    this.itemName = item.name;
    console.log(item);

    this.visible = false;
  }
  deleteItem(service) {
    this.lstServices = this.lstServices.filter((t) => t.service_id !== service);
  }
  deleteItem2(service) {
    this.itemsAll = this.itemsAll.filter((t) => t.name !== service);
  }
  addSoc() {
    this.onChange();
    this.allIds.push(this.itemId);
    this.lstServices.push({
      service_id: this.itemId,
      service_name: this.itemName,
      service_price: this.itemAmount,
      discount_percent: this.discount,
      discount_price: this.discountPrice,
      net_amt: this.netAmount,
    });
    this.stateForm.patchValue({
      lstServices: this.lstServices,
    });
    this.itemId = '';
    this.itemName = '';
    this.itemAmount = 0;
    this.discount = 0;
    this.discountPrice = 0;
    this.netAmount = 0;
  }
  addSocPrice() {
    let data = {
      soc_id: +this.copyForm.value.select_soc,
      item_id: this.itemId,
      amount: +this.copyForm.value.amount,
      name: this.itemName,
    };
    if (!data.soc_id) {
      this._snackBar.open('Please select a valid SOC', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
      return;
    }
    if (!data.item_id) {
      this._snackBar.open('Please select a valid service', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
      return;
    }
    if (!data.amount) {
      this._snackBar.open('Please input a valid amount', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
      return;
    }
    this.itemsAll.push(data);

    console.log(this.copyForm.value);
    console.log('data', data);
    this.copyForm.patchValue({
      amount: 0,
    });
    this.itemName = '';
  }
  add() {
    this.onChange();
    this.allIds.push(this.itemId);
    this.lstServices.push({
      service_id: this.itemId,
      service_name: this.itemName,
      service_price: this.itemAmount,
      discount_percent: this.discount,
      discount_price: this.discountPrice,
      net_amt: this.netAmount,
    });
    this.stateForm.patchValue({
      lstServices: this.lstServices,
    });
    this.itemId = '';
    this.itemName = '';
    this.itemAmount = 0;
    this.discount = 0;
    this.discountPrice = 0;
    this.netAmount = 0;
  }

  add1() {
    console.log(this.itemId, this.discount, this.SOC_ID);
    this.isLoading1 = true;
    this.Errors = null;
    this.Success = null;
    this.auth.postSocsItem(this.SOC_ID, this.itemId, this.discount).subscribe(
      (resSuccess) => {
        this.data = resSuccess;
        this.isLoading1 = false;
        console.log(resSuccess);

        if (this.data.success) {
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.discount = null;
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
        }
      },
      (resErr) => {
        this.isLoading1 = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  onChange() {
    // this.discountPrice = this.percentage(this.discount, this.itemAmount)
    this.netAmount = this.itemAmount - this.discountPrice;

    console.log(
      this.discountPrice,
      this.netAmount,
      this.itemAmount,
      this.itemId,
      this.itemName
    );
  }
  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const { SOC_ID, SOC_NAME, SOC_Short_COde, SOC_REMARKs, Status, Author_Id } =
      this.stateForm.value;
    this.auth
      .postSocs(
        SOC_ID,
        SOC_NAME,
        SOC_Short_COde,
        SOC_REMARKs,
        Status,
        Author_Id
      )
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);

          if (this.data.success) {
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }

  onCopy(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    let ids = '';
    if (this.allIds.length === 0) {
      ids = '0';
    } else {
      ids = this.allIds.toString();
    }
    const { select_soc, base_soc, rate_type, rate_percent } =
      this.copyForm.value;
    this.auth
      .copySoc(select_soc, base_soc, rate_type, rate_percent, ids)
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);

          if (this.data.success) {
            this.closeModal();
            this._snackBar.open(this.data.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this._snackBar.open('Error: please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log('error');
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }
  onAddPrice(e) {
    console.log(this.itemsAll);
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;

    this.auth.addPriceSoc(this.itemsAll).subscribe(
      (resSuccess) => {
        this.data = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (this.data.success) {
          // this.onCopy(e);
          this.closeModal();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this._snackBar.open('Error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log('error');
        }
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth.getSocs().subscribe(
      (resSuccess) => {
        this.socs = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.auth.getItems().subscribe(
      (resSuccess: any) => {
        this.items = resSuccess;
        console.log(this.items);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
    this.auth.getCompanies().subscribe(
      (resSuccess: any) => {
        this.companies = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getBranches().subscribe(
      (resSuccess: any) => {
        this.branchs = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  back() {
    this.mode = null;
  }
  viewAll(soc) {
    this.mode = 'view';
    this.auth.getItemBySocId(soc.SOC_ID).subscribe(
      (resSuccess: any) => {
        this.socItems = resSuccess;
        console.log(this.socItems, 'Socccccccc');
        this.isLoading = false;
      },
      (resErr) => {
        this.Errors = resErr;
        this.isLoading = false;
      }
    );
  }
  addNew() {
    this.mode = 'add';
  }
  copy() {
    this.mode = 'copy';
  }
  price() {
    this.mode = 'price';
  }
  edit(soc) {
    this.SOC_ID = soc.SOC_ID;
    this.mode = 'edit';
    this.stateForm.patchValue({
      SOC_NAME: soc.SOC_NAME,
      SOC_REMARKs: soc.SOC_REMARKs,
      SOC_ID: soc.SOC_ID,
      SOC_Short_COde: soc.SOC_Short_COde,
      Status: soc.Status,
    });
    console.log(this.stateForm.value);
  }

  delete(title) {
    this.auth.delSet('/api/soc/deleteSOC', title.SOC_ID).subscribe(
      (resSuccess) => {
        this.socs = this.socs.filter(
          (dattum) => dattum.SOC_ID !== title.SOC_ID
        );
        this._snackBar.open('Deleted Successfully', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      },
      (resErr) => {
        this._snackBar.open('Error try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }
}
